module.exports = __webpack_public_path__ + "static/media/poweredByZodot.ba795f51.png";